import { useDeal } from '../features/deal-context';

export function DealHeader() {
  const { data: deal, isLoading, error } = useDeal();

  if (isLoading) {
    return (
      <div className="bg-white rounded-lg border border-gray-200 p-4 animate-pulse">
        <div className="h-6 bg-gray-200 rounded w-2/5 mb-2" />
        <div className="h-4 bg-gray-100 rounded w-1/5" />
      </div>
    );
  }

  if (error) {
    return (
      <div className="bg-red-50 border border-red-200 rounded-lg p-4 text-red-700 text-sm">
        <span className="font-medium">Ошибка загрузки сделки:</span> {error.message}
      </div>
    );
  }

  return (
    <div className="bg-white rounded-lg border border-gray-200 p-4">
      <h1 className="text-lg font-semibold text-gray-900">{deal?.TITLE ?? '—'}</h1>
      <p className="text-xs text-gray-400 mt-0.5">ID сделки: {deal?.ID}</p>
    </div>
  );
}
